import * as sections from "components/Homeowner/CaseForms/ComparableGrid/Sections/Sections";

export const BBTMValueSections = [
  sections.FEATURE,
  sections.COMPARABLE_TYPE,
  sections.ADDRESS,
  sections.LATITUDE,
  sections.LONGITUDE,
  sections.ADDRESS_2,
  sections.CITY,
  sections.STATE,
  sections.ZIP,
  sections.PROXIMITY_TO_SUBJECT,
  sections.SALE_PRICE,
  sections.SALE_PRICE_GLA,
  sections.DATA_SOURCES_1004P,
  sections.VALUE_ADJUSTMENTS,
  sections.SALE_DATE_BBT,
  sections.LOCATION,
  sections.LOCATION_RATING,
  sections.LOCATION_TYPE,
  sections.LOCATION_TYPE_1_OTHER,
  sections.LOCATION_TYPE_2,
  sections.LOCATION_TYPE_2_OTHER,
  sections.SITE_BBT,
  sections.SQUARE_FEET,
  sections.ACRES,
  sections.QUALITY_BBT,
  sections.ACTUAL_AGE_BBT,
  sections.CONDITION_BBT,
  sections.ABOVE_GRADE_BBT,
  sections.ABOVE_GRADE_ROOM_COUNT_BBT,
  sections.TOTAL_BBT,
  sections.BEDROOMS_BBT,
  sections.BATHROOMS_BBT,
  sections.HALF_BATHROOMS_BBT,
  sections.GLA_BBT,
  sections.BASEMENT_FINISHED_BBT,
  sections.BELOW_GRADE_TOT_SF_BBT,
  sections.BELOW_GRADE_FIN_SF_BBT,
  sections.BASEMENT_EXIT_TYPE_BBT,
  sections.GARAGE_CARPORT_BBT,
  sections.DRIVEWAY_BBT,
  sections.NUM_OF_CARS_BBT,
  sections.CAR_STORAGE_1_BBT,
  sections.ATTACHMENT_TYPE_1_BBT,
  sections.NUM_OF_CARS_1_BBT,
  sections.CAR_STORAGE_2_BBT,
  sections.ATTACHMENT_TYPE_2_BBT,
  sections.NUM_OF_CARS_2_BBT,
  sections.OTHER_BBT,
  sections.COMPARISON_TO_SUBJECT,
  sections.COMMENTS
];

export const BBTMValueComparableCount = {
  minComparables: 3,
  maxComparables: 3
};